import { useRouter } from "next/router";
import Navbar from "./../pages/Navbar";
import FooterWithSubscribe from "../pages/footer";

export default function Layout({ children }) {
    const router = useRouter();

    const hideLayout = [
        "/login",
        "/quester/onboarding",
        "/expert/onboarding",
        "/mobile-call/[slug]",
        "/call/[slug]",
    ];

    const shouldHideLayout = hideLayout.some((route) => {
        if (route.includes("[slug]")) {
            const routePattern = route.replace("/[slug]", "");
            return router.pathname.startsWith(routePattern);
        }
        return router.pathname === route;
    });

    const isMobileCallRoute =
        router.pathname.includes("/mobile-call/") ||
        router.query?.mobile === "true" ||
        router.query?.platform === "react-native";

    const hide = shouldHideLayout || isMobileCallRoute;

    return (
        <>
            {!hide && <Navbar />}
            <main className="bg-cream-50">{children}</main>
            {!hide && (
                <div className="bg-cream-50">
                    <FooterWithSubscribe />
                </div>
            )}
        </>
    );
}
